import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
import usePlanner from '@/composables/usePlanner';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Index',
    setup(__props) {
        const { planners, criteria, totalPage, searchPlanner } = usePlanner();
        // 検索ボタン: 条件を変えたときは 1 ページ目から表示する
        const search = () => {
            criteria.value.page = 1;
            searchPlanner();
        };
        // ページ番号を押したとき（Vuetify 3 の v-pagination は input ではなく update:modelValue を発生させる）
        const onPageChange = (page) => {
            criteria.value.page = page;
            searchPlanner();
        };
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_table = _resolveComponent("v-table");
            const _component_v_pagination = _resolveComponent("v-pagination");
            const _component_v_container = _resolveComponent("v-container");
            return (_openBlock(), _createBlock(_component_v_container, null, {
                default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => _cache[1] || (_cache[1] = [
                                    _createElementVNode("h2", null, "プランナー一覧", -1)
                                ])),
                                _: 1,
                                __: [1]
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_form, null, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { cols: "3" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_text_field, {
                                                                modelValue: _unref(criteria).name,
                                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(criteria).name) = $event)),
                                                                label: "プランナー名"
                                                            }, null, 8, ["modelValue"])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_btn, { onClick: search }, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                            _createTextVNode("検索")
                                        ])),
                                        _: 1,
                                        __: [2]
                                    })
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_table, {
                                style: { "width": "100%" },
                                density: "compact"
                            }, {
                                default: _withCtx(() => [
                                    _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", null, "ID"),
                                            _createElementVNode("th", null, "プランナー名")
                                        ])
                                    ], -1)),
                                    _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(planners), (planner) => {
                                            return (_openBlock(), _createElementBlock("tr", null, [
                                                _createElementVNode("td", null, _toDisplayString(planner.id), 1),
                                                _createElementVNode("td", null, _toDisplayString(planner.name), 1)
                                            ]));
                                        }), 256))
                                    ])
                                ]),
                                _: 1,
                                __: [3]
                            })
                        ]),
                        _: 1
                    }),
                    _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_col, null, {
                                default: _withCtx(() => [
                                    _createVNode(_component_v_pagination, {
                                        "model-value": _unref(criteria).page,
                                        length: _unref(totalPage),
                                        "onUpdate:modelValue": onPageChange
                                    }, null, 8, ["model-value", "length"])
                                ]),
                                _: 1
                            })
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
